<template>
    <div id="quoter-component">

        <b-modal @hide="closeModal" v-model="showModal" v-if="(role_id === 1)" id="modal-cotizador" hide-footer
            size="xl" centered scrollable :title="titleModal" ref="modal-serv">

            <ticket-quoter-workers-client v-if="modalTicketQuoter" @close-modal="closeModal"
                :quoter_id="quoter_id_ticket">
            </ticket-quoter-workers-client>
            <form v-if="modalForm" id="" class="formQuoter">
                <input type="hidden" name="totalPkg" id="totalPkg">
                <div class="row">
                    <div class="col-12">
                        <cite>*Campos requeridos con linea roja. Recuerda que se usa la fecha de inicio de contrato y se
                            toma la fecha del día en curso y los meses que se calculan son los transcuridos.</cite>
                    </div>
                </div>

                <h2 class="cabeza">Contratantes</h2>
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <select name="client_id" id="client_id" v-model="quoter.client_id"
                            v-on:change="getExpirationDate($event)">
                            <option :value="0">Seleccione un cliente</option>
                            <option v-for="client in clients" v-if="client.expirationcontract != null"
                                :data-start="client.expirationcontract.start_date"
                                :data-end="client.expirationcontract.expiration_date" :quoter-id="client.quoting_id"
                                :value="client.id">
                                {{ client.sku }} - {{ client.nmComPerMoral }}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-6">
                        <select name="extra_prima" id="extra_prima" v-model="quoter.extra_prima">
                            <option :value="0">Agregar Extra Prima</option>
                            <option :value="1">Si</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-4 mt-3">
                        <p>
                            <input v-model="quoter.start_date" class="al-inputs scr-input" type="text" id="start_date"
                                name="start_date" data-name-input="start_date" placeholder="Inicio de Vigencia" />
                            <label for="start_date" class="scr-supertext">Inicio de Vigencia</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4 mt-3">
                        <p>
                            <input v-model="quoter.diff_months" class="al-inputs scr-input" type="text" id="diff_months"
                                name="diff_months" data-name-input="diff_months" placeholder="Diferencia en Meses" />
                            <label for="expiration_date" class="scr-supertext">Meses transcurridos</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4 mt-3">
                        <p>
                            <input v-model="quoter.num_workers" class="al-inputs scr-input" type="text" id="num_workers"
                                name="num_workers" data-name-input="num_workers" placeholder="Número de Afiliados"
                                v-on:keyup="calculatePrice()" />
                            <label for="num_workers" class="scr-supertext">Número de Afiliados</label>
                        </p>
                    </div>
                </div>
                <div v-show="showResults" class="row">
                    <div class="col-12 col-sm-3 text-center">
                        <h6 class="scr-supertext">Total costo x per.</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.total_cost_per_person)">
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6 class="scr-supertext">Cant. prorrateada.</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.apportionment)">
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6 class="scr-supertext">Extra prima</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.amount_affiliate_extra_prima)">
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6>Total Gasto por Per.</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.total_expense_per_person)">
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6>I.v.a de la cotización</h6>
                        <select v-model="quoter.percent_iva" id="percent_iva"
                            @change="calculatePrice(quoter.percent_iva)">
                            <option :value="0.08">8%</option>
                            <option :value="0.16">16%</option>
                        </select>
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6>I.v.a</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.iva)">
                    </div>
                    <div class="col-12 col-sm-3 text-center">
                        <h6>Total</h6>
                        <input type="text" readonly class="scr-input text-center" style="height: 40px"
                            :value="formatPrice(quoter.total_cost)">
                    </div>
                </div>
                <!-- BTN GUARDAR -->
                <div class="row">
                    <div class="col-12">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar">
                            Guardar Cotización
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <cite>Campos obligatorios*</cite>
                    </div>
                </div>
            </form>
        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0" v-if="(role_id === 1)">
                            <button class="formSubmit" type="button" v-on:click="openModalsProviders('quoter')">
                                Cotizar
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                            :items="pagination.data" :filter="filter">
                            <template #head(acciones)="{ item }">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(Cliente)="{ item }">
                                <template v-if="item.client.nombre">
                                    {{ item.client.nombre }}
                                </template>
                                <template v-else>
                                    {{ item.client.nmComPerMoral }}
                                </template>
                            </template>
                            <template #cell(Numero_de_afiliados)="{ item }">
                                {{ item.num_workers }}
                            </template>
                            <template #cell(Costo_gasto_por_Persona)="{ item }">
                                {{ formatPrice(item.total_cost_per_person) }}
                            </template>
                            <template #cell(Costo_por_Persona)="{ item }">
                                {{ formatPrice(item.total_expense_per_person) }}
                            </template>
                            <template #cell(iva)="{ item }">
                                {{ formatPrice(item.iva) }}
                            </template>
                            <template #cell(total)="{ item }">
                                {{ formatPrice(item.total_cost) }}
                            </template>
                            <template #cell(pdf)="{ item }">

                                <a v-if="item.pdf != null" :href="path_storage + 'workers/' + item.pdf"
                                    class="badge rounded-pill text-bg-blue" target="_blank">
                                    <i class="fas fa-file-pdf"></i>
                                </a>

                                <span v-else></span>
                            </template>
                            <template #cell(pago)="{ item }">
                                <a v-if="item.pdf != null && item.ticket != null"
                                    :href="path_storage + 'ticket_cotizacion/' + item.ticket.ticket"
                                    class="badge rounded-pill text-bg-blue" target="_blank">
                                    <i class="fa-solid fa-ticket"></i>
                                </a>

                                <span v-else></span>
                            </template>
                            <template #cell(status)="{ item }">
                                <span v-if="item.approved_at != null" class="badge rounded-pill text-bg-success"><i
                                        class="fa-solid fa-circle-check"></i></span>
                                <span v-else class="badge rounded-pill text-bg-orange"><i
                                        class="fa-solid fa-circle-exclamation"></i></span>
                            </template>
                            <template #cell(acciones)="{ item }">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="modificar = true; edit_quoter(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="approved_quoter(item)">Aprobar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="print_pdf(item.id)">Imprimir</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="onClickDeleteTicket(item.ticket.id)">
                                            Borrar Ticket
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="onClickDelete(item.id)">
                                            Borrar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
import { myMixins } from "../mixins/myMixins";
import { quotersService } from "../../Services/Quoters.service";
import { clientsService } from "../../Services/Clients.service";
import { extraUserQuoterService } from "../../Services/ExtraUserQuoter.service";
import { ticketQuoterWorkerService } from "../../Services/TicketQuoterWorker.service";

export default {
    name: "quoter-workers",
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            amountAffiliateExtraPrima: 0,
            quoter_id_ticket: 0,
            showResults: false,
            filter: null,
            modalForm: false,
            showModal: false,
            isBusy: false,
            modificar: false,
            approved_at: false,
            workers: {},
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            fields: [
                { key: 'Cliente' },
                { key: 'Numero_de_afiliados' },
                { key: 'Costo_por_Persona' },
                { key: 'Costo_gasto_por_Persona' },
                { key: 'iva' },
                { key: 'total' },
                { key: 'pdf' },
                { key: 'pago' },
                { key: 'status' },
                { key: 'acciones' },
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            path_storage: '../storage/quotings/',
            clients: [],
            quoter: {
                id: 0,
                client_id: 0,
                start_date: '',
                apportionment: 0,
                diff_months: 0,
                num_workers: 0,
                total_cost_per_person: 0,
                total_expense_per_person: 0,
                percent_iva: 0,
                iva: 0,
                subtotal: 0,
                total_cost: 0,
                extra_prima: 0,
            },
            quoter_active: [],
        }
    },
    methods: {
        async onClickDeleteTicket(id) {
            let resp = await ticketQuoterWorkerService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await extraUserQuoterService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formQuoter');
            if (this.quoter.num_workers > 0) {
                if (respVal) {

                    if (this.modificar) {
                        resp = await extraUserQuoterService.updateOne(this.quoter.id, this.quoter);
                    } else {
                        resp = await extraUserQuoterService.saveOne(this.quoter);
                    }
                    this.getAlert(resp.process);
                    this.modificar = false;
                    this.showModal = false;
                    this.setEmpty();
                    await this.index();
                }
            } else {
                this.getAlert('no_employees');
            }
            //this.modificar = false;
        },
        async index() {
            //ORDEN DE LOS FINANCIAMIENTOS
            this.isBusy = true;
            this.clients = await clientsService.getClientAsCompany();
            this.pagination = await extraUserQuoterService.getMany(this.params);
            this.isBusy = false;
        },
        async print_pdf(id) {
            this.isBusy = true;
            let resp = await extraUserQuoterService.printQuote(id);
            this.getAlert(resp.process);
            this.isBusy = false;
        },
        async calculatePrice(percent) {
            try {
                // Obtener la cotización activa del cliente
                this.quoter_active = await quotersService.getOne(this.quoter.quoting_id);

                // Validar si los campos requeridos están completos
                if (this.quoter_active.costo_x_persona === '' || this.quoter_active.gasto_x_persona === '') {
                    this.getAlert('no_quoter_complete');
                    return;
                }

                // Actualizar el porcentaje de IVA
                this.quoter.percent_iva = percent != null ? percent : +this.quoter_active.percent_iva;

                // Parsear y asignar los valores necesarios
                const iva = this.quoter.percent_iva;
                const costPerPerson = +this.parsePrice(this.quoter_active.costo_x_persona);
                //console.log('costPerPerson', costPerPerson);
                const costPerDcto = +this.parsePrice(this.quoter_active.costo_x_per_dcto);
                //console.log('costPerDcto', costPerDcto);
                const administrativeExpenses = +this.parsePrice(this.quoter_active.gasto_x_persona);
                const numWorkers = +this.quoter.num_workers;
                if (this.quoter.extra_prima !== 0) {
                    this.amountAffiliateExtraPrima = +this.parsePrice(this.quoter_active.amount_affiliate_extra_prima);
                    this.quoter.amount_affiliate_extra_prima = this.amountAffiliateExtraPrima;
                    //console.log('amountAffiliateExtraPrima', this.amountAffiliateExtraPrima);
                }

                // Calcular costos totales
                this.quoter.total_cost_per_person = costPerDcto ? (costPerDcto * numWorkers) : (costPerPerson * numWorkers);
                this.quoter.total_expense_per_person = administrativeExpenses * numWorkers;

                // Calcular IVA y total según el número de meses restantes
                if (this.quoter.diff_months >= 0 && this.quoter.diff_months <= 5) {
                    //AQUI DEBO TAMBIEN SUMAR SI EXISTE EXTRA PRIMERA
                    this.quoter.iva = (this.quoter.total_cost_per_person + this.quoter.total_expense_per_person + this.amountAffiliateExtraPrima) * iva;
                    this.quoter.total_cost = this.quoter.total_cost_per_person + this.quoter.total_expense_per_person + this.quoter.iva;

                } else if (this.quoter.diff_months >= 6 && this.quoter.diff_months <= 11) {

                    const diffMonths = 12 - this.quoter.diff_months;
                    //SI EXISTE EXTRA PRIMA AQUI SE LO DEBO DE SUMAR ANTES DE DIVIDIR ENTRE 12
                    //console.log('this.quoter.total_cost_per_person=', this.quoter.total_cost_per_person, ' - this.amountAffiliateExtraPrima=', this.amountAffiliateExtraPrima, ' - div 12=', (this.quoter.total_cost_per_person + this.amountAffiliateExtraPrima / 12), ' - diffMonths=', diffMonths);
                    this.quoter.apportionment = (((this.quoter.total_cost_per_person + this.amountAffiliateExtraPrima) / 12) * diffMonths);
                    //console.log('Prorrateo = ', this.quoter.apportionment);
                    //EL SUBTOTAL ES EL COSTO TOTAL POR PERSONA ENTRE 12 MESES POR LOS MESES RESTANTES MAS EL GASTO POR PERSONA
                    this.quoter.subtotal = this.quoter.apportionment + this.quoter.total_expense_per_person;
                    this.quoter.iva = this.quoter.subtotal * iva;
                    this.quoter.total_cost = this.quoter.subtotal + this.quoter.iva;
                }

                this.showResults = true;
            } catch (error) {
                console.error('Error calculating price:', error);
            }
        },

        async edit_quoter(data = {}) {
            //console.log('data', data);
            if (this.modificar) {
                this.showResults = true;
                this.tituloBtn = 'Actualizar';
                this.quoter = data;
                this.quoter.quoting_id = data.client.quoting_id;
                this.quoter.start_date = data.client.expirationcontract.start_date;
                this.openModalsProviders('quoter');
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        approved_quoter(item) {
            //console.log(item);
            this.quoter_id_ticket = item.id;
            this.renew_status = item.renew;
            (item.approved_at !== null) ? this.approved_at = true : this.approved_at = false;
            this.openModalsProviders('ticket_quoter');
        },
        changeLimit() {
            this.index();
        },
        calcularDiferenciaEnMeses(fechaProporcionada) {
            // Fecha de hoy
            let fechaHoy = new Date();

            // Calcula la diferencia en meses
            return (fechaHoy.getFullYear() - fechaProporcionada.getFullYear()) * 12 + (fechaHoy.getMonth() - fechaProporcionada.getMonth());
        },

        closeModal() {
            //console.log('cerrando el modal');
            this.setEmpty();
        },
        getExpirationDate($event) {
            this.quoter.quoting_id = $event.target.options[$event.target.options.selectedIndex].getAttribute('quoter-id');
            this.quoter.start_date = $event.target.options[$event.target.options.selectedIndex].getAttribute('data-start');
            this.quoter.end_date = $event.target.options[$event.target.options.selectedIndex].getAttribute('data-end');
            this.quoter.diff_months = Number(this.calcularDiferenciaEnMeses(new Date(this.quoter.start_date)));

            //console.log('this.quoter.diff_months', this.quoter.diff_months, ',this.quoter.start_date=',this.quoter.start_date, ',this.quoter.quoting_id=',this.quoter.quoting_id);
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        setEmpty() {

        },
    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
.reservation-box {
    background-color: #f1f1f1;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    margin-bottom: 20px;
    padding: 15px;
    text-align: center;
}

.reservation-box .person-counter .titleCounter {
    border-bottom: 1px solid #e3e3e3;
    font-size: 12px;
    letter-spacing: .1rem;
    margin-bottom: 14px;
    margin-right: 10px;
    margin-top: 5px;
    padding-bottom: 10px;
    text-transform: uppercase;
}

.reservation-box .person-counter .amount {
    height: 25px;
    line-height: 26px;
    margin: 0 5px;
}

.reservation-box .person-counter .button {
    background-color: #fff;
    border: 0;
    border-radius: 15px;
    color: #000;
    display: inline-block;
    font-size: 14px;
    height: 25px;
    line-height: 27px;
    text-align: center;
    width: 25px;
    vertical-align: baseline;
}

.reservation-box .person-counter span.amount {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    vertical-align: bottom;
}

#percent_iva {
    margin-top: 0 !important;
    height: 40px;
}
</style>
